"use client";

import React from "react";
import { Mail, MapPin, Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardDescription, CardTitle } from "@/components/ui/card";
const contactMethods = [{
  title: "Phone",
  value: "+243 810 641 198\n\xA0+243 840 161 875\n+243 840 161 875",
  icon: Phone,
  link: "tel:+243810641198",
  isLink: true
}, {
  title: "Email",
  value: "ddchambangi@gmail.com",
  icon: Mail,
  link: "mailto:ddchambangi@gmail.com",
  isLink: true
}, {
  title: "Location",
  value: "N’djili International Airport, DR Congo",
  icon: MapPin,
  link: "",
  isLink: false
}];
export default function ConnectWithOurHub() {
  return <section id="connect-with-our-hub" className="dark bg-background text-foreground relative py-24 overflow-hidden">
      {}
      <div className="absolute inset-0 pointer-events-none z-0">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_bottom,_var(--color-secondary)_0%,_transparent_70%)] opacity-50" />
        
        {}
        <div className="absolute bottom-[10%] left-[15%] md:left-[25%] w-2 h-2 rounded-full bg-primary shadow-[0_0_20px_var(--color-primary)]" />
        <div className="absolute bottom-[30%] left-[30%] md:left-[35%] w-1.5 h-1.5 rounded-full bg-primary shadow-[0_0_15px_var(--color-primary)] opacity-80" />
        <div className="absolute bottom-[50%] left-[40%] md:left-[43%] w-1 h-1 rounded-full bg-primary shadow-[0_0_10px_var(--color-primary)] opacity-50" />
        <div className="absolute bottom-[70%] left-[45%] md:left-[47%] w-0.5 h-0.5 rounded-full bg-primary shadow-[0_0_5px_var(--color-primary)] opacity-30" />

        <div className="absolute bottom-[10%] right-[15%] md:right-[25%] w-2 h-2 rounded-full bg-primary shadow-[0_0_20px_var(--color-primary)]" />
        <div className="absolute bottom-[30%] right-[30%] md:right-[35%] w-1.5 h-1.5 rounded-full bg-primary shadow-[0_0_15px_var(--color-primary)] opacity-80" />
        <div className="absolute bottom-[50%] right-[40%] md:right-[43%] w-1 h-1 rounded-full bg-primary shadow-[0_0_10px_var(--color-primary)] opacity-50" />
        <div className="absolute bottom-[70%] right-[45%] md:right-[47%] w-0.5 h-0.5 rounded-full bg-primary shadow-[0_0_5px_var(--color-primary)] opacity-30" />
      </div>

      <div className="container mx-auto px-4 relative z-10 max-w-6xl">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold tracking-tight mb-4">
            Connect with Our Hub
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
            Reach out to our dedicated team for reliable aviation logistics and ground handling support.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {contactMethods.map((method, i) => <div data-index={i} key={method.title} className="h-full">
              <Card className="h-full bg-card/40 backdrop-blur-md border-border/50 flex flex-col items-center text-center p-8 hover:bg-card/60 hover:border-primary/30 transition-all duration-500 group">
                <div className="p-5 rounded-full bg-primary/10 mb-6 group-hover:scale-110 group-hover:bg-primary/20 transition-all duration-500">
                  <method.icon className="size-10 text-primary" strokeWidth={1.5} />
                </div>
                <CardTitle className="text-xl mb-3 font-semibold tracking-wide">
                  {method.title}
                </CardTitle>
                <CardDescription className="text-base text-muted-foreground mt-auto">
                  {method.isLink ? <Link to={method.link} className="hover:text-primary transition-colors duration-300">
                      {method.value}
                    </Link> : <span>{method.value}</span>}
                </CardDescription>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}